import { Dispatch, Commit, ActionContext } from 'vuex';
import { sortBy as _sortBy } from '@lodash';
import StoreUtil from '@app/store/StoreUtil';
import {
    SET_FAVOURITE,
    DELETE_FAVOURITE,
    SET_RANDOM_NUMBERS_AMOUNT,
    SET_FAVOURITES_SAVING,
    SET_FAVOURITES,
    SET_SELECTED_FAVOURITES,
    SET_ARE_FAVOURITES_FETCHED_UPON_LOGIN,
    UPDATE_TIMESTAMP,
    SET_SELECTED_SIDEBAR_COMPONENT,
} from '@store/modules/ui/lotto/mutationTypes';
import { ILottoState } from './types';
import UserService from '@core/services/user/UserService';
import { removeEventQueryParams } from '@app/utils';
import { ExpandedEventInUrl } from '@app/enums';
import { IState } from '@app/store';
import { getTimeSpanForTimeFilter } from '@shared/timeFilter/helpers';
import { SET_IS_LOADING } from './betSlip/mutationTypes';

export default {
    async setFavourite(
        { commit, dispatch }: { commit: Commit, dispatch: Dispatch, state: ILottoState },
        { lottoId, favourite }: { lottoId: number, favourite: number[]}
    ) {
        const sortedFavourite = _sortBy(favourite);
        commit(SET_SELECTED_FAVOURITES, sortedFavourite);
        try {
            await dispatch('saveLottoFavourites');
            commit(SET_FAVOURITE, { lottoId, favourite: sortedFavourite });
        } catch (e) {
            throw e;
        }
    },
    async deleteFavourite(
        { commit, dispatch }: { commit: Commit, dispatch: Dispatch },
        { lottoId, favouriteIndex }: { lottoId: number, favouriteIndex: number }
    ) {
        try {
            dispatch('saveLottoFavourites');
        } catch (e) {
            throw e;
        }
        commit(DELETE_FAVOURITE, { lottoId, favouriteIndex });
    },
    clearUserSpecificData: ({ commit }: { commit: Commit }) => {
        commit(SET_FAVOURITES, {});
        commit(SET_ARE_FAVOURITES_FETCHED_UPON_LOGIN, false);
    },
    async getLottoFavourites({ commit }: { commit: Commit }) {
        try {
            const favourites = await UserService.getInstance().getLottoFavorites();
            commit(SET_ARE_FAVOURITES_FETCHED_UPON_LOGIN, true);
            commit(SET_FAVOURITES, favourites);
        } catch (e) {
            throw e;
        }
    },
    saveLottoFavourites: StoreUtil.asyncErrorGuard(
        async ({ state, commit }: { state: ILottoState, commit: Commit }
        ) => {
            try {
                commit(SET_FAVOURITES_SAVING, true);
                await UserService.getInstance().setLottoFavorites(state.favourites);
                commit(SET_FAVOURITES_SAVING, false);
                return;
            } catch (e) {
                commit(SET_FAVOURITES_SAVING, false);
                throw e;
            }
        }),
    setSelectedFavourites: StoreUtil.createSimpleMutatorAction(SET_SELECTED_FAVOURITES),
    setRandomNumbersAmount: StoreUtil.createSimpleMutatorAction(SET_RANDOM_NUMBERS_AMOUNT),
    setSelectedSidebarComponent: StoreUtil.createSimpleMutatorAction(SET_SELECTED_SIDEBAR_COMPONENT),
    toggleExpandedEvent: (
        { commit, getters, rootGetters, dispatch }:
            { getters: any, rootGetters: any, commit: Commit, dispatch: Dispatch },
        eventId: number
    ) => {
        let query = rootGetters['navigation/route'].query;

        if (!eventId || getters.expandedEventId === eventId) {
            query = removeEventQueryParams(query);
        } else {
            commit(UPDATE_TIMESTAMP);
            query = {
                ...query,
                [ExpandedEventInUrl.event]: eventId.toString(),
            };
        }

        dispatch(
            'navigation/push',
            {
                query,
                path: rootGetters['navigation/route'].path,
            },
            { root: true }
        );
    },
    async loadLottoOffer(context: ActionContext<ILottoState, IState>) {
        const timeFilter = context.getters.timeFilter;
        const timeSpan = getTimeSpanForTimeFilter(timeFilter);
        context.commit(SET_IS_LOADING, true);
        await context.dispatch('data/lottoOffer/fetchLottoEvents', timeSpan, { root: true });
        context.commit(SET_IS_LOADING, false);
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/actions.ts